module.exports = __webpack_public_path__ + "img/_Header_Desktop_Logo.b0531009.png";